module.exports = __webpack_public_path__ + "static/media/iphone2.faa74fc7.png";